module.exports = __webpack_public_path__ + "ai-botwp0be522a317e185103309e94789f0562c.png";